export  const generateReadableError=(e)=>{
    
    let readableError = (e.response && e.response.data && e.response.data.responseMessage)?e.response.data.responseMessage:null
    /*if(e.response && e.response.status && (e.response.status==401 || e.response.status==403)){
        localStorage.setItem('message',JSON.stringify({status:'danger',message:`${readableError}`}));
        window.location.href = '/login';
    }*/
    
    return {code:(e.response && e.response.status)?e.response.status:null, status:'danger',message:(readableError)?readableError:(e.response && e.response.status && e.response.status===401)?'You are not authorized to perform this action':'Server Error'};
}